import { date, dateTime } from '@/lib/format';

/** 「2026-09-19 15:40」：年月日用 lib/format 的 date，时分取自 dateTime（lib 没有带年份的时刻格式，建议补一个） */
export function fullTime(v?: string | null) {
  return v ? `${date(v)} ${dateTime(v).slice(6)}` : '—';
}

export function fileSize(n?: number | null) {
  if (!n) return '';
  if (n < 1024 * 1024) return `${Math.max(1, Math.round(n / 1024))} KB`;
  return `${(n / 1024 / 1024).toFixed(1)} MB`;
}
